module.exports = __webpack_public_path__ + "img/empty.f335d610.svg";